import { images } from "@/data/resort";
import { Eyebrow, MaskReveal, Reveal } from "../reveal";
import { cn } from "@/lib/utils";

const featured = [
  {
    id: "laundry",
    title: "On-Site Laundry",
    copy: "Refresh your travel wardrobe without leaving the resort. On-site laundry facilities make longer road trips and extended stays easier and more convenient.",
    label: "Convenient for Weekly & Extended Stays",
    image: images.amenityLaundry,
    alt: "On-site laundry machines at Auburn RV Resort",
    span: "md:col-span-7 md:row-span-2",
    ratio: "aspect-[4/5] md:aspect-auto md:min-h-[34rem]",
  },
  {
    id: "showers",
    title: "Bath & Shower Facilities",
    copy: "Freshen up after a day on the road or an afternoon exploring Auburn and the surrounding Sierra Foothills with convenient on-site bath and shower facilities.",
    label: "Refresh. Reset. Keep Exploring.",
    image: images.amenityBathhouse,
    alt: "Clean bath and shower facilities at Auburn RV Resort",
    span: "md:col-span-5 md:row-span-2",
    ratio: "aspect-[4/5] md:aspect-auto md:min-h-[34rem]",
  },
  {
    id: "dogpark",
    title: "Fenced Dog Park",
    copy: "A secure dedicated area for your dog to stretch and enjoy time outside.",
    alt: "Fenced dog park at Auburn RV Resort",
    span: "md:col-span-4",
    ratio: "aspect-[4/3]",
  },
  {
    id: "wifi",
    title: "Complimentary WiFi",
    copy: "Stay connected during your travels with WiFi available for Auburn RV Resort guests.",
    alt: "Comfortable RV site stay with connectivity at Auburn RV Resort",
    span: "md:col-span-4",
    ratio: "aspect-[4/3]",
  },
  {
    id: "outdoor",
    title: "Outdoor Picnic + BBQ",
    copy: "Picnic tables and a dedicated BBQ area make outdoor meals and downtime easy.",
    image: images.amenityOutdoor,
    alt: "BBQ area and outdoor dining space at Auburn RV Resort",
    span: "md:col-span-4",
    ratio: "aspect-[4/3]",
  },
];

export function FeaturedAmenities() {
  return (
    <section
      id="during-your-stay"
      aria-labelledby="featured-amenities-heading"
      className="scroll-mt-16 bg-secondary/40 py-16 md:py-20"
    >
      <div className="shell">
        <Reveal>
          <Eyebrow>During Your Stay</Eyebrow>
        </Reveal>
        <h2 id="featured-amenities-heading" className="display-lg mt-6 max-w-[20ch]">
          <MaskReveal>Designed Around the Way</MaskReveal>
          <MaskReveal delay={0.08}>RV Travelers Actually Travel</MaskReveal>
        </h2>

        <div className="mt-10 grid gap-4 md:grid-cols-12 md:auto-rows-[minmax(16rem,auto)]">
          {featured.map((item, i) => (
            <Reveal key={item.id} delay={i * 0.05} className={cn("group", item.span)}>
              <article className="relative h-full overflow-hidden bg-forest-deep text-primary-foreground">
                {"image" in item && item.image && <img
                  src={item.image}
                  alt={item.alt}
                  width={1200}
                  height={1400}
                  loading="lazy"
                  decoding="async"
                  className={cn(
                    "size-full object-cover transition-transform duration-700 group-hover:scale-[1.03]",
                    item.ratio,
                  )}
                />}
                <div className="absolute inset-0 bg-gradient-to-t from-forest-deep/90 via-forest-deep/35 to-transparent" />
                <div className="absolute inset-x-0 bottom-0 p-6 md:p-8">
                  {"label" in item && item.label && (
                    <p className="eyebrow text-accent">{item.label}</p>
                  )}
                  <h3 className="font-display mt-3 text-2xl tracking-tight md:text-3xl">
                    {item.title}
                  </h3>
                  <p className="mt-3 max-w-md text-sm leading-relaxed text-primary-foreground/80">
                    {item.copy}
                  </p>
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
